/*
 * <newsletter-popup> — native welkomst-/nieuwsbrief-popup (geen app).
 * Verschijnt na een vertraging of bij verlaat-intentie, frequency-capped via localStorage.
 * Toegankelijk: role=dialog, focus-trap, ESC, scroll-lock. Na een geslaagde inschrijving
 * (full-page POST van {% form 'customer' %}) toont 'ie de kortingscode en onthoudt 'ie dat.
 */
(function () {
  const DISMISSED = 'themerie:np:dismissed';
  const SUBSCRIBED = 'themerie:np:subscribed';

  function nowMs() {
    return new Date().getTime();
  }

  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.np__dialog');
      this.form = this.querySelector('.np__form');
      this.reward = this.querySelector('[data-np-reward]');
      this.justPosted = !!this.querySelector('[data-np-posted]');
      this.delay = (parseInt(this.dataset.delay, 10) || 6) * 1000;
      this.frequencyMs = (parseInt(this.dataset.frequency, 10) || 14) * 86400000;
      this.exitIntent = this.dataset.exitIntent === 'true';
      this.scrollPercent = parseInt(this.dataset.scroll, 10) || 0;
      this.onScroll = this.onScroll.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onMouseOut = this.onMouseOut.bind(this);

      this.querySelectorAll('[data-np-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      const codeBtn = this.querySelector('[data-np-code]');
      if (codeBtn) codeBtn.addEventListener('click', () => this.copyCode(codeBtn));

      if (this.justPosted) {
        // Net ingeschreven → toon de beloning en onthoud het.
        this.setFlag(SUBSCRIBED, '1');
        if (this.form) this.form.hidden = true;
        if (this.reward) this.reward.hidden = false;
        this.open();
        return;
      }

      if (this.getFlag(SUBSCRIBED) === '1') return;
      if (this.recentlyDismissed()) return;
      this.schedule();
    }

    getFlag(k) {
      try {
        return localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    }

    setFlag(k, v) {
      try {
        localStorage.setItem(k, v);
      } catch (e) {
        /* stil falen */
      }
    }

    recentlyDismissed() {
      const t = parseInt(this.getFlag(DISMISSED), 10);
      return t && nowMs() - t < this.frequencyMs;
    }

    schedule() {
      this.timer = setTimeout(() => this.open(), this.delay);
      if (this.exitIntent) document.addEventListener('mouseout', this.onMouseOut);
      if (this.scrollPercent) window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    onScroll() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && (window.scrollY / max) * 100 >= this.scrollPercent) this.open();
    }

    onMouseOut(e) {
      if (e.clientY <= 0 && !e.relatedTarget) this.open();
    }

    open() {
      if (this.opened) return;
      this.opened = true;
      clearTimeout(this.timer);
      document.removeEventListener('mouseout', this.onMouseOut);
      window.removeEventListener('scroll', this.onScroll);
      this.previousFocus = document.activeElement;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.classList.add('np-lock');
      document.addEventListener('keydown', this.onKey);
      const focusable = this.dialog.querySelector('input, button');
      if (focusable) focusable.focus();
    }

    close() {
      this.opened = false;
      this.classList.remove('is-open');
      document.body.classList.remove('np-lock');
      document.removeEventListener('keydown', this.onKey);
      this.setFlag(DISMISSED, String(nowMs()));
      setTimeout(() => {
        this.hidden = true;
      }, 300);
      if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus();
    }

    onKey(e) {
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;
      const f = this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    async copyCode(btn) {
      const code = btn.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
        btn.classList.add('is-copied');
        const label = btn.querySelector('.np__code-copy');
        if (label) label.textContent = btn.dataset.copied || '✓';
      } catch (e) {
        /* clipboard kan geblokkeerd zijn — code blijft zichtbaar om handmatig te kopiëren */
      }
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }
})();
